<template>
    <default-view-layout title="Manage Products">
        <products-manager></products-manager>
    </default-view-layout>
</template>

<script>
import DefaultViewLayout from "Layouts/DefaultViewLayout";
import ProductsManager from "Components/ProductsManager";

export default {
    components: {
        DefaultViewLayout,
        ProductsManager,
    },
};
</script>

<style scoped lang="scss"></style>
